(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[81243,40659,81066,75847,44709,40852,74453,44954,40617],{

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ })

}]);